var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPerson({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10.7337 4.73333C10.7337 6.24291 9.50995 7.46667 8.00038 7.46667C6.4908 7.46667 5.26704 6.24291 5.26704 4.73333C5.26704 3.22375 6.4908 2 8.00038 2C9.50995 2 10.7337 3.22375 10.7337 4.73333ZM9.9512 7.91704C11.0205 7.26042 11.7337 6.08016 11.7337 4.73333C11.7337 2.67147 10.0622 1 8.00038 1C5.93851 1 4.26704 2.67147 4.26704 4.73333C4.26704 6.08017 4.98024 7.26042 6.04956 7.91705C3.96166 8.74221 2.40039 10.7398 2.40039 12.3333C2.40039 14.3952 6.03225 15 8.00039 15C9.96853 15 13.6004 14.3952 13.6004 12.3333C13.6004 10.7397 12.0391 8.7422 9.9512 7.91704ZM12.6004 12.3333C12.6004 12.6573 12.3171 13.103 11.2044 13.4973C10.1897 13.8569 8.91039 14 8.00039 14C7.09039 14 5.81112 13.8569 4.79635 13.4973C3.68365 13.103 3.40039 12.6573 3.40039 12.3333C3.40039 11.6836 3.84777 10.731 4.75668 9.89689C5.6416 9.08474 6.8101 8.53333 8.00039 8.53333C9.19068 8.53333 10.3592 9.08474 11.2441 9.89689C12.153 10.731 12.6004 11.6836 12.6004 12.3333Z",
    fill: "#717C8C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.8191561db249d3c368259ddb4c1d9503.svg";
export { ForwardRef as ReactComponent };